// extracted by mini-css-extract-plugin
export default {"body":"AccountActivated_body__2nHOK","alert":"AccountActivated_alert__bew7j"};